import { gql } from '@apollo/client'

export const EXPORT_POLICY_UPDATER_QUERY = gql`
  query ExportPolicyUpdater($userID: String!) {
    user(userID: $userID) {
      name
      username
    }
  }
`

export const ADMIN_CONFIG_LOG = gql`
  query AdminConfigLog {
    adminConfigLog {
      enabledLogging
      totals {
        totalRecords
        integrityStatus
      }
      integrityStatus {
        name
        status
        checkedAt
      }
      thresholdSettings {
        numberOfRecords
        enabledSMSNotifications
        intervalSMSNotifications
        mobileNumbers
      }
      failedLogRetention {
        retentionPeriodDays
        enabledSMSNotifications
        intervalSMSNotifications
        mobileNumbers
      }
    }
  }
`

export const ADMIN_CONFIG_SECURITY = gql`
  query AdminConfigSecurity {
    adminConfigSecurity {
      enforcedTwoFactorAuthentication
      sessionConfiguration {
        maxSessionsPerUser
        idleSessionTimeoutMinutes
        absoluteSessionTimeoutMinutes
      }
    }
  }
`

export const ADMIN_CONFIG_SESSIONS = gql`
  query AdminConfigSessions($input: AdminConfigSessionsInput!) {
    adminConfigSessions(input: $input) {
      totalCount
      sessions {
        sessionId
        status
        initiatedAt
        lastActivity
        terminatedAt
        expireMinutes
        absoluteMinutes
        user {
          username
          email
        }
      }
    }
  }
`

export const AUDIT_LOG_INTEGRITY_QUERY = gql`
  query AuditLogsIntegrity {
    auditLogsIntegrity {
      trackingID
    }
  }
`

export const MODIFY_ADMIN_CONFIG_LOG = gql`
  mutation ModifyAdminConfigLog($input: ModifyAdminConfigLogInput!) {
    modifyAdminConfigLog(input: $input) {
      message
    }
  }
`

export const MODIFY_ADMIN_CONFIG_SESSION = gql`
  mutation ModifyAdminConfigSession($input: ModifyAdminConfigSessionInput!) {
    modifyAdminConfigSession(input: $input) {
      message
    }
  }
`

export const TENANT_EXPORT_CONFIGURATION_QUERY = gql`
  query TenantExportConfiguration {
    tenantExportConfiguration {
      maxRows
      maxArtifactSizeMegabytes
    }
  }
`

export const UPDATE_TENANT_EXPORT_CONFIGURATION_MUTATION = gql`
  mutation UpdateTenantExportConfiguration(
    $input: UpdateTenantExportConfigurationInput!
  ) {
    updateTenantExportConfiguration(input: $input) {
      maxRows
      maxArtifactSizeMegabytes
    }
  }
`

export const EXPORT_POLICY_CONFIGURATION_QUERY = gql`
  query ExportPolicyConfiguration {
    exportPolicyConfiguration {
      defaultLimits {
        maxRows
        maxFileSizeMegabytes
      }
      operationOverrides {
        operation
        limits {
          maxRows
          maxFileSizeMegabytes
        }
      }
      revision
      updatedAt
      updatedBy
    }
  }
`

export const UPDATE_EXPORT_POLICY_CONFIGURATION_MUTATION = gql`
  mutation UpdateExportPolicyConfiguration(
    $input: UpdateExportPolicyConfigurationInput!
  ) {
    updateExportPolicyConfiguration(input: $input) {
      defaultLimits {
        maxRows
        maxFileSizeMegabytes
      }
      operationOverrides {
        operation
        limits {
          maxRows
          maxFileSizeMegabytes
        }
      }
      revision
      updatedAt
      updatedBy
    }
  }
`

export const AUDIT_LOG_JOB_HANDLER_SUB = gql`
  subscription AuditLogsJobHandler($trackingID: String!) {
    auditLogsJobHandler(trackingID: $trackingID) {
      status
      progressPercent
      message
      trackingID
    }
  }
`
